// extracted by mini-css-extract-plugin
export var checkboxInputRow = "H_vY";
export var checkboxInputColumn = "H_vZ";
export var inputOptionRow = "H_sn";
export var inputOptionColumn = "H_sp";